import { DeliveryZoneCode } from '@noths/polaris-client-localisation';
import { createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit';

import { DeliveryZoneOptions } from 'src/types';
import { requestDeliveryZoneOptions } from './thunks';

export interface DeliveryZoneOptionsState {
  error: SerializedError | null;
  isLoading: boolean;
  options: DeliveryZoneOptions;
  selectedZone: DeliveryZoneCode | '';
  selectedCountry: string | '';
}

export const initialState: Readonly<DeliveryZoneOptionsState> = {
  error: null,
  isLoading: true,
  options: [],
  selectedZone: 'MAINLAND_UK',
  selectedCountry: 'GB',
};

export interface SelectCountryPayload {
  selectedZone: DeliveryZoneCode;
  selectedCountry: string;
  sectionParent: 'delivery-area' | 'delivery-summary';
}

export const { actions, reducer } = createSlice({
  name: 'requestDeliveryZoneOptions',
  initialState,
  reducers: {
    setSelectedZone: (state, { payload }: PayloadAction<DeliveryZoneCode | undefined>) => {
      if (payload) {
        state.selectedZone = payload;
      }
    },
    setSelectedCountry: (
      state,
      { payload }: PayloadAction<SelectCountryPayload | string | undefined>,
    ) => {
      if (payload) {
        state.selectedCountry = typeof payload === 'object' ? payload.selectedCountry : payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(requestDeliveryZoneOptions.fulfilled, (state, { payload }) => {
        state.options = payload;
        state.isLoading = false;
      })
      .addCase(requestDeliveryZoneOptions.rejected, (state, action) => {
        state.error = action.error;
        state.isLoading = false;
      });
  },
});
